import _ from 'lodash';

import user from 'js/lib/user';

import localStorageEx from 'bundles/common/utils/localStorageEx';

const getKey = (orgId: string) => `${orgId}~${user.get().external_id}~PROGRAMS_LAST_VISITED`;

export type Program = {
  name: string;
  slug: string;
};

const safelyFilter = (any?: { name: string; slug: string }[]): Program[] =>
  any?.filter((el) => el?.name && el?.slug) || [];

export const addProgramToLocalStorage = (program: Program, orgId: string) => {
  const key = getKey(orgId);
  const existingPrograms = safelyFilter(localStorageEx.getItem(key, JSON.parse, []));
  // add  program to start of  array, remove duplicates, limit size to 3
  const newPrograms = _.uniqBy(
    [{ name: program.name, slug: program.slug }, ...existingPrograms],
    (el) => el.slug
  ).slice(0, 3);
  localStorageEx.setItem(key, newPrograms, JSON.stringify);
};

export const getProgramsFromLocalStorage = (orgId: string): Program[] =>
  safelyFilter(localStorageEx.getItem(getKey(orgId), JSON.parse, []));

/**
 * Updates the name of programs in local storage and removes archived programs
 * @param updatedPrograms list of all NON-ARCHIVED programs in org
 * @param orgId id of org
 */
export const updateProgramsInLocalStorage = (updatedPrograms: Program[], orgId: string) => {
  const key = getKey(orgId);
  const programsInStorage = getProgramsFromLocalStorage(orgId);
  const updatedProgramsInStorage: Program[] = [];

  programsInStorage.forEach((program) => {
    const updatedProgram = updatedPrograms.find((p) => p.slug === program.slug);
    if (updatedProgram) updatedProgramsInStorage.push({ name: updatedProgram.name, slug: updatedProgram.slug });
  });
  localStorageEx.setItem(key, updatedProgramsInStorage, JSON.stringify);
};
